<template>
  <div class="pageContol templateList">
    <div class="framePage">
      <div class="framePage-title">
        <span>
          <em>当前位置：</em>
          <a href="javascript:;">考试管理</a>
          <i>></i>
          <a href="javascript:;">题库管理</a>
          <i>></i>
          <a href="javascript:;" @click="$router.back()">题库内容</a>
          <i>></i>
          <a href="javascript:;" class="cur-a" v-if="lastPageData.subjectId == '1'">科目一</a>
          <a href="javascript:;" class="cur-a" v-if="lastPageData.subjectId == '2'">科目二</a>
          <a href="javascript:;" class="cur-a" v-if="lastPageData.subjectId == '3'">科目三</a>
          <a href="javascript:;" class="cur-a" v-if="lastPageData.subjectId == '4'">科目四</a>
        </span>
      </div>
      <div class="framePage-body">
        <div class="operationControl flexcb" style="align-items: flex-start">
          <p>科目标识：{{ lastPageData.itemCode }} 科目名称：{{ lastPageData.itemName }}</p>
          <el-button size="small" @click="$router.back();" class="bgc-bv">返 回</el-button>
        </div>
        <div class="framePage-scroll">
          <div class="ovy-a">
            <div class="ovy_l">
              <div class="ovy_l_1" @click="openAddEdit()">新增考核内容</div>
              <div class="ovy_l_2" @click="currentActive(index)" v-for="(item, index) in itemContentList" :key="index">
                <div class="ovy_l_2_1">{{ lastPageData.itemCode }}-{{ index + 1 }}</div>
                <div class="ovy_l_2_2">{{ item.contentTitle }}</div>
              </div>
            </div>
            <div class="ovy_r">
              <div class="shell" :id="'paperItem' + index" v-for="(item, index) in itemContentList" :key="index">
                <div class="ovy_r_1">
                  <div class="ovy_r_1_1"><i class="el-icon-edit" @click="openAddEdit(item)"></i>{{ item.contentTitle }}
                  </div>
                  <div class="ovy_r_1_2">
                    <el-button type="primary" size="mini" icon="el-icon-plus"
                      @click="addAndEditSmallSubject(item)">新增试题</el-button>
                    <el-button type="danger" size="mini" icon="el-icon-delete"
                      @click="deleteAssessmentContent(item)">删除大题</el-button>
                  </div>
                </div>
                <div class="ovy_r_2" v-for="(item1, index1) in item.questionList" :key="index1">
                  <div class="ovy_r_2_1">
                    <div class="ovy_r_2_1_1">
                      <div class="ovy_r_2_1_1_1">{{ $setDictionary("PA_QUESTION_TYPE", item1.questionType) }}</div>
                      <div class="ovy_r_2_1_1_2">
                        {{ item1.questionName }}
                        <span v-if="item1.groupName">（{{item1.ticketName}}{{ item1.groupName }}）</span>
                      </div>
                    </div>
                    <div class="ovy_r_2_1_2" v-if="['10', '20', '30', '90', '95','110','125'].includes(item1.questionType)">
                      <p class="flexca" v-for="(item2, index2) in item1.optionJson" :key="index2">{{ item2.key }}：
                        <el-image style="width: 60px; height: 60px" :src="item2.img" :preview-src-list="srcList"
                          @click="preview_img(item2.img)" v-if="item2.img">
                        </el-image>
                        <span v-else>{{ item2.content }}</span>
                      </p>
                    </div>
                    <div class="ovy_r_2_1_2" v-if="['91'].includes(item1.questionType)">
                      <p class="flexca" v-for="(item2, index2) in item1.optionJson" :key="index2">{{ item2.serial }}：
                        <span v-if="item2.content">{{ item2.content }}</span>
                        <span v-else>填空项</span>
                      </p>
                    </div>
                    <div class="ovy_r_2_1_2" v-if="['120'].includes(item1.questionType)">
                      <p class="flexca" v-for="(item2, index2) in item1.optionJson" :key="index2">{{ item2.key }}：
                        <el-image style="width: 60px; height: 60px" :src="item2.img" :preview-src-list="srcList"
                          @click="preview_img(item2.img)" v-if="item2.img">
                        </el-image>
                        <span v-else>
                          <P>温度：{{item2.temperature}}</P>
                          <P>天气：{{ item2.weather }}</P>
                          <P>风速：{{ item2.windSpeed }}</P>
                          <P>可作业：{{ item2.safeWork }}</P>
                        </span>
                      </p>
                    </div>
                    <div class="ovy_r_2_1_3" v-if="['10', '20', '30', '90'].includes(item1.questionType)">
                      正确答案：{{ item1.standardAnswer }}
                    </div>
                  </div>
                  <div class="ovy_r_2_2">
                    <div class="ovy_r_2_2_1">
                      <el-button type="primary" size="mini" @click="previewFile(item1)"
                        v-if="item1.materialType">预览</el-button>
                      <el-button type="warning" size="mini" icon="el-icon-edit"
                        @click="addAndEditSmallSubject(item, item1)">编辑</el-button>
                      <el-button type="danger" size="mini" icon="el-icon-delete"
                        @click="deleteSmallSubject(item1)">删除</el-button>
                    </div>
                    <div class="ovy_r_2_2_2">分数：<span class="c-red">{{ item1.score }}</span> 分</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 弹框 - 新增&编辑 - 考核内容 -->
    <el-dialog :title="assessmentContent.aaaid ? '编辑考核内容' : '新增考核内容'" :visible.sync="assessmentContent.dialogVisible"
      width="500px" @close="closeAddEdit">
      <el-form ref="assessmentContent" label-width="100px" size="small" :rules="assessmentContentRules"
        :model="assessmentContent">
        <el-form-item label="考核内容:" prop="contentTitle">
          <el-input type="textarea" v-model="assessmentContent.contentTitle" clearable placeholder="请输入考核内容" />
        </el-form-item>
        <el-form-item label="考试图贴" class="form-item ylfile">
        <el-upload class="up_video" :on-change="handleAvatarSuccess3" :http-request="$requestMine"
          :show-file-list="false" :before-remove="beforeRemove" action
          accept="image/png, image/gif, image/jpg, image/jpeg">
          <el-button class="bgc-bv">点击上传</el-button>
        </el-upload>
        <template v-if="assessmentContent.blueprint">
          <el-button style="margin-left: 10px;" type="primary" size="mini" plain icon="el-icon-folder-opened"
            @click="previewBlueprint">预览文件</el-button>
          <el-button style="margin-left: 10px;" type="danger" size="mini" plain icon="el-icon-delete"
            @click="d_previewBlueprint">删除</el-button>
        </template>
      </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAddEdit" class="bgc-bv">取 消</el-button>
        <el-button size="small" @click="openAddEditOk" class="bgc-bv">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 弹框 - 新增&编辑 - 题库 -->
    <el-dialog title="预览文件" :visible.sync="previewFileData.dialogVisible" width="600px" destroy-on-close
      @close="closePreviewFile">
      <img :src="previewFileData.questionMaterialUrl" alt="" style="width: 100%;height: 100%;"
        v-if="previewFileData.materialType == 'IMAGE'">
      <video :src="previewFileData.questionMaterialUrl" autoplay controls width="100%" height="500px"
        v-if="previewFileData.materialType == 'VIDEO'"></video>
    </el-dialog>
    <!-- 弹框 - 预览考试贴纸 -->
    <el-dialog title="预览考试贴纸" :visible.sync="blueprintData.dialogVisible" width="1000px" destroy-on-close
      @close="closepreviewBlueprint">
      <img :src="assessmentContent.blueprintUrl" alt="" style="width: 100%;height: 100%;">
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "examinationAffairsManage_questionBank_info_list",
  components: {},
  data() {
    return {
      // 上个页面传过来的数据
      lastPageData: {
        bankId: "", // 题库id
        itemId: "", // 考核科目id
        subjectId: "", // 科目id
        itemCode: "", // 科目标识
        itemName: "", // 科目名称
      },
      // 新增&编辑 - 考核内容
      assessmentContent: {
        dialogVisible: false, // 弹框状态
        contentId: "", // 考核内容id
        contentTitle: "", // 考核内容
        blueprint: "", // 考核内容图纸
        blueprintUrl: "", // 考核内容图纸-预览地址
      },
      // 新增&新增弹框数据校验
      assessmentContentRules: {
        contentTitle: [
          { required: true, message: "请输入考核内容", trigger: "blur" },
        ],
      },
      // 预览 - 考试贴纸 - 弹框
      blueprintData: {
        dialogVisible: false, // 弹框状态
      },
      // 科目试题列表
      itemContentList: [],
      // 预览 - 题目图片/视频 - 弹框
      previewFileData: {
        dialogVisible: false, // 弹框状态
        materialType: "", // 文件类型
        questionMaterialUrl: "", // 文件地址
      },
      // 预览 - 试题选项图片 - 图片集合
      srcList: [],
    };
  },
  computed: {},
  mounted() {
  },
  created() {
    this.lastPageData.bankId = this.$route.query?.bankId ?? ""; // 题库id
    this.lastPageData.itemId = this.$route.query?.itemId ?? ""; // 考核科目id
    this.lastPageData.subjectId = this.$route.query?.subjectId ?? ""; // 科目id
    this.lastPageData.itemCode = this.$route.query?.itemCode ?? ""; // 科目标识
    this.lastPageData.itemName = this.$route.query?.itemName ?? ""; // 科目名称
    this.getItemContentList();
  },
  methods: {
    // 获取 - 该科目下 - 该考核内容(包含试题列表)
    getItemContentList() {
      this.$post("/biz/bank/pa-question-bank/itemContentList", {
        itemId: this.lastPageData.itemId
      }, 3000, true, 10)
        .then((res) => {
          for (let i = 0; i < res.data.length; i++) {
            for (let n = 0; n < res.data[i].questionList.length; n++) {
              if (res.data[i].questionList[n].optionJson) {
                res.data[i].questionList[n].optionJson = JSON.parse(res.data[i].questionList[n].optionJson);
              }
            }
          }
          this.itemContentList = res.data;
          console.log(this.itemContentList);
        })
        .catch((err) => {
          return;
        });
    },
    // 左侧点击跳到锚点指定位置
    currentActive(index) {
      let id = 'paperItem' + index;
      const currentDom = document.getElementById(id);
      if (currentDom) {
        currentDom.scrollIntoView({
          behavior: 'smooth' // 让滚动更丝滑
        }) // 你也可以设置丝滑滚动
      }
    },
    // 新增&编辑 - 考核内容标题 - 打开弹框
    openAddEdit(item) {
      if (item) {
        this.assessmentContent.contentId = item.contentId;
        this.assessmentContent.contentTitle = item.contentTitle;
        this.assessmentContent.blueprint = item.blueprint;
        this.assessmentContent.blueprintUrl = item.blueprintUrl;
      }
      this.assessmentContent.dialogVisible = true;
    },
    // 新增&编辑 - 考核内容标题 - 上传 - 图纸
    handleAvatarSuccess3(res) {
      let extension = res.name.substring(res.name.lastIndexOf(".") + 1);
      let formData = new FormData();
      formData.append("folder ", "PRACTICAL_QUESTION_BANK");
      formData.append("file ", res.raw);
      formData.append("fileType ", extension);
      formData.append("isPublic", false);
      const isLt2M = res.size / 1024 / 1024 < 100;
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 100MB!");
      } else {
        this.$Postformat("/sys/file/upload/url", formData,3000, true, 10)
          .then((result) => {
            console.log(result);
            this.assessmentContent.blueprint = result.data.fileKey;
            this.assessmentContent.blueprintUrl = result.data.fileUrl;
            console.log(this.assessmentContent)
          })
          .catch((err) => {
            setTimeout(() => {
              this.$message({
                type: "warning",
                message: "上传失败",
              });
            }, 300);
          });
      }
    },
    // 预览 - 图纸
    previewBlueprint() {
      this.blueprintData.dialogVisible = true;
    },
    // 关闭预览 - 图纸
    closepreviewBlueprint() {
      this.blueprintData.dialogVisible = false;
    },
    // 删除 - 图纸
    d_previewBlueprint() {
      this.assessmentContent.blueprint = "";
      this.assessmentContent.blueprintUrl = "";
    },
    // 新增&编辑 - 考核内容标题 - 关闭弹框
    closeAddEdit() {
      this.assessmentContent = this.$options.data().assessmentContent;
    },
    // 新增&编辑 - 考核内容标题 - 打开弹框 - 确定
    openAddEditOk() {
      this.$refs['assessmentContent'].validate((valid) => {
        if (valid) {
          let url = '';
          if (this.assessmentContent.contentId) {
            url = '/biz/bank/pa-question-bank/modifyItemContent';
          } else {
            url = '/biz/bank/pa-question-bank/addItemContent';
          }
          this.$post(url, {
            itemId: this.lastPageData.itemId,
            ...this.assessmentContent
          }, 3000, true, 10)
            .then((res) => {
              this.$message.success('操作成功');
              this.closeAddEdit();
              this.getItemContentList();
            })
            .catch((err) => {
              return;
            });
        }
      })
    },
    // 删除 - 内容
    deleteAssessmentContent(item) {
      this.$post("/biz/bank/pa-question-bank/delContent", {
        contentId: item.contentId
      }, 3000, true, 10)
        .then((res) => {
          this.$message.success('操作成功');
          this.getItemContentList();
        })
        .catch((err) => {
          return;
        });
    },
    // 预览 - 题目图片/视频
    previewFile(item1) {
      this.previewFileData.materialType = item1.materialType;
      this.previewFileData.questionMaterialUrl = item1.questionMaterialUrl;
      this.previewFileData.dialogVisible = true;
    },
    // 关闭预览 - 题目图片/视频
    closePreviewFile() {
      this.previewFileData = this.$options.data().previewFileData;
    },
    // 新增||编辑 - 内容中的题
    addAndEditSmallSubject(item, item1) {
      this.$router.push({
        path: "/practicalAssessmentSystem/examinationAffairsManage/questionBank_info_list_set",
        query: {
          contentId: item?.contentId, // 考核内容id
          questionId: item1?.questionId ?? '', // 考题id(编辑用)
          ...this.lastPageData
        }
      })
    },
    // 删除 - 内容中的题
    deleteSmallSubject(item1) {
      this.$post("/biz/bank/pa-question-bank/delQuestion", {
        questionId: item1.questionId
      }, 3000, true, 10)
        .then((res) => {
          this.$message.success('操作成功');
          this.getItemContentList();
        })
        .catch((err) => {
          return;
        });
    },
    // 预览图片
    preview_img(item) {
      this.srcList = [item];
    },
    // 预览视频
    preview_video() {

    },
  },
};
</script>
<style lang="less" scoped>
.ovy-a {
  display: flex;

  .ovy_l {
    width: 180px;
    overflow-y: auto;
    padding-right: 20px;
    cursor: pointer;

    .ovy_l_1 {
      background: #5C6BE8;
      color: #fff;
      text-align: center;
      width: 100px;
      font-size: 12px;
      line-height: 30px;
      border-radius: 4px;
      margin: auto;
    }

    .ovy_l_2 {
      width: 100%;
      border: 1px solid #2379ff;
      margin-top: 10px;
      border-radius: 4px;
      cursor: pointer;
      overflow: hidden;

      .ovy_l_2_1 {
        width: 100%;
        text-align: center;
        line-height: 25px;
        color: #2379ff;
        background: #edf5ff;

      }

      .ovy_l_2_2 {
        font-size: 12px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        padding: 2px 4px;
        height: 40px;
      }

      &:hover {
        .ovy_l_2_1 {
          color: #fff;
          background: #2379ff;
        }
      }
    }
  }

  .ovy_r {
    overflow-y: auto;
    flex: 1;
    padding: 0 10px 0 20px;

    .shell {
      .ovy_r_1 {
        background: #efefef;
        padding: 4px 6px;
        font-size: 13px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;

        .ovy_r_1_1 {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: calc(100% - 210px);

          i {
            color: #e7a33a;
            cursor: pointer;
            margin-right: 10px;
          }
        }

        .ovy_r_1_2 {
          min-width: 205px;
        }
      }

      .ovy_r_2 {
        border: 1px solid #75abff;
        border-radius: 8px;
        overflow: hidden;
        padding: 10px 8px 10px 16px;
        display: flex;
        justify-content: space-between;
        cursor: pointer;
        margin-bottom: 10px;
        min-height: 102px;

        &:hover {
          background: #eff7ff;
        }

        .ovy_r_2_1 {
          max-width: calc(100% - 222px);
          overflow-x: auto;
          .ovy_r_2_1_1 {
            display: flex;

            .ovy_r_2_1_1_1 {
              min-width: 50px;
              font-size: 12px;
              border: 1px solid #75abff;
              border-radius: 4px;
              line-height: 20px;
              height: 20px;
              padding: 0 4px;
            }

            .ovy_r_2_1_1_2 {
              padding: 0 8px;
            }
          }

          .ovy_r_2_1_2 {
            display: flex;
            margin-top: 10px;
           
            p {
              margin-right: 20px;
              min-width: 100px;
              word-break: break-all;
            }
          }

          .ovy_r_2_1_3 {
            color: #95d373;
            margin-top: 10px;
          }
        }

        .ovy_r_2_2 {
          min-width: 222px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .ovy_r_2_2_1 {
            text-align: right;
          }
          .ovy_r_2_2_2 {
            text-align: right;
          }
        }
      }
    }
  }
}
.ylfile {
  /deep/ .el-form-item__content {
    display: flex;
  }
}
.up_video {
  width: 80px;

  /deep/ .el-upload {
    border: 0 !important;
    height: 32px;
  }
}
</style>
